import { AnswerLevel } from '../model/models';
import { colors, fonts, breakpoints } from '../styles';
import levelMappingToColor from '../styles/levelMappingToColor';
import AnswerButton from './AnswerButton';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const backgroundType = 'shortcut';

interface AnswersProps {
    onAnswer: (answerLevel: AnswerLevel) => void;
    loading?: boolean;
    previousAnswer?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    survey_id: any;
    levels_state: any;
    showLevels?: boolean;
}
const AnswersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 300px;
`;
const AnswersWrapperFixed = styled(AnswersWrapper)`
    height: 120px;
    width: 300px;
    align-items: center;
    margin: 0 auto;
`;
const Text = styled.div`
    color: ${colors.libertyBlue};
    ${fonts.textContent};
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

const SizedAnswer = styled(AnswerButton)`
    height: 50px;
`;

const YesNoButton = styled(SizedAnswer)`
    min-width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    
    ${breakpoints.onlyMobile} {
        margin: 0 auto;
    }
`;

const Answers: React.FC<AnswersProps> = ({
    onAnswer,
    survey_id,
    levels_state,
    loading,
    previousAnswer,
    showLevels = true,
}) => {
    const [answerLoading, setAnswerLoading] = useState(-1);

    return (<>
    {  showLevels?
        <AnswersWrapper>
            {
                levels_state &&
                levels_state.levels_data.map((level: any) => (
                    <SizedAnswer
                        key={level.id}
                        index={level.id}
                        levels_state={levels_state}
                        level={level.level}                        color={level.color}
                        shortcut={level.level.toString()}
                        backgroundType={backgroundType}
                        showShortcut={true}
                        loading={
                            previousAnswer === level.level ||
                            (loading && answerLoading === level.level)
                        }
                        onClick={() => {
                            setAnswerLoading(level.level);
                            onAnswer(level.level);
                        }}
                    />
                )) } </AnswersWrapper> :            <AnswersWrapperFixed>
                <YesNoButton
                    key={1}
                    level={1}
                    index={2}
                    color={levels_state.levels_data[1].color}
                    shortcut={'1'}
                    backgroundType={'content'}
                    children={
                        <Text>
                        {'Yes'}
                    </Text>
                    }
                    showShortcut={false}
                    loading={previousAnswer === 1 || (loading && answerLoading === 1)}
                    onClick={() => {
                        setAnswerLoading(1);
                        onAnswer(1);
                    } }
                ></YesNoButton>
                <YesNoButton
                    key={0}
                    level={0}
                    index={1}
                    color={levels_state.levels_data[0].color}
                    shortcut={'0'}
                    showShortcut={false}
                    backgroundType={'content'}
                    loading={previousAnswer === 2 || (loading && answerLoading === 2)}
                    children={
                        <Text>
                        {'No'}
                    </Text>
                    }
                    onClick={() => {
                        setAnswerLoading(0);
                        onAnswer(0);
                    } }
                ></YesNoButton>
                </AnswersWrapperFixed>
            }
        </>
    );
};

export default Answers;